import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import MachinesApiService from './_services/machines.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    machines: [],
  },
  mutations: {
    [MutationTypes.SET_MACHINES](state, payload) {
      state.machines = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_MACHINES](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, ...rest },
    ) {
      commit(MutationTypes.SET_MACHINES, await MachinesApiService.getMachines({ suffix, ...rest }));
    },
  },
};
